import React, { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Typography, Icon } from 'shared/ui'
import { IS_CALLING_APP_LIGHT } from 'shared/config'
import { type DefaultInboxStore } from 'entities/DeviceSettings'
import styles from './styles.module.scss'

export type IDefaultInboxContentProps = {
  defaultInboxStore: DefaultInboxStore
  onOpenInboxSelect: () => void
}

export const DefaultInboxContent: FC<IDefaultInboxContentProps> = observer(
  ({ defaultInboxStore, onOpenInboxSelect }) => {
    if (!IS_CALLING_APP_LIGHT) return null

    const label = defaultInboxStore.defaultInboxName || 'Select'

    return (
      <div className={styles.section}>
        <div className={styles.dropdownContent}>
          <div
            className={classnames(styles.dropdownWrap, styles.dropdownWrapClickable)}
            onClick={onOpenInboxSelect}
          >
            <div className={styles.dropdownBox}>
              <Typography
                className={styles.label}
                variant='body-md-regular'
                ariaLabel='Default Inbox'
              >
                Default Inbox
              </Typography>
            </div>
            <div className={styles.inboxSelectTrigger}>
              <Typography
                className={styles.inboxSelectLabel}
                variant='body-md-regular'
                ariaLabel='selected-inbox'
              >
                {label}
              </Typography>
              <Icon icon='chevronRight' fontSize={16} className={styles.inboxSelectIcon} />
            </div>
          </div>
        </div>
      </div>
    )
  }
)
